export default (text) => String(text)
  .trim()
  .replace(/\n/g, '<br />');
